import React from 'react';
import { useDispatch } from 'react-redux';
import { setSearchTerm } from '@actions/search';
import styles from './Hashtag.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Hashtag(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleHashtagClick = (e) => {
    e.preventDefault();
    dispatch(setSearchTerm(props.decoratedText, true));
    if (location.pathname !== '/search') {
      navigate('/search');
    }
  };

  return (
    <span className={styles.hashtag} onClick={handleHashtagClick}>
      {props.children}
    </span>
  );
}
